import { render, staticRenderFns } from "./LoggedUserButton.vue?vue&type=template&id=b15eab7a"
import script from "./LoggedUserButton.vue?vue&type=script&lang=js"
export * from "./LoggedUserButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports